<template>
  <UApp :toaster="toasterConfig">
    <div>
      <NuxtLoadingIndicator class="bg-cred" :color="false" />
      <NuxtLayout>
        <NuxtPage />
        <ConsentModal />
      </NuxtLayout>
    </div>
  </UApp>
</template>

<script setup lang="ts">
const toasterConfig = {
  position: 'bottom-right' as const,
  expand: true,
  progress: false,
  duration: 5000,
}
</script>
